import { call, select, StrictEffect } from 'redux-saga/effects'

import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Select, Workspace } from '../../lib/toolBoxes/2D'
import { GeometricDrawable, selectActiveGeometryGroupId, selectDrawableGeometries } from '../../slices/geometry'

export function* handleToggleActiveDrawableGroups2D(): Generator<
    StrictEffect | number[],
    void,
    PaperManager & Workspace & Select & GeometricDrawable[] & paper.Item[] & (number | null) & number[] & paper.Item
> {
    try {
        const manager: PaperManager = yield call(managers.get2DManager)

        if (!manager) return

        const workspaceTool: Workspace = yield call(manager.getTool, Workspace.NAME)

        const allDrawables: GeometricDrawable[] = yield select(selectDrawableGeometries)

        const activeDrawableGroupId: number | null = yield select(selectActiveGeometryGroupId)

        if (!activeDrawableGroupId) return

        const activeDrawableIds: number[] = yield allDrawables.reduce((idArray, drawable) => {
            return drawable.opening_group_id === activeDrawableGroupId ? [...idArray, drawable.id] : idArray
        }, [] as number[])

        yield call(workspaceTool.lockItems, true, activeDrawableIds)
    } catch (error) {
        yield call(console.error, error)
    }
}
